import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CheckCircle2, Truck } from "lucide-react";
import { toast } from "sonner";

const SCELTE = [["bonifico", "Bonifico"], ["pos", "POS"], ["contanti", "Contanti"], ["assegno", "Assegno"], ["", "Non specificato"]];
let opener = null;

// Dopo il salvataggio di una fattura già pagata (rilevato dall'AI) chiede il metodo e lo salva.
export const afterAiFattura = async (fatt, form) => {
  if (fatt?.fornitore_completato?.length) toast.info(`Anagrafica fornitore completata: ${fatt.fornitore_completato.join(", ")}`);
  if (!form?.ai_pagato || !fatt?.id || !opener) return;
  const m = await opener(form.ai_metodo || "");
  if (!m) return;
  try {
    await api.post("/fatture/bulk-mezzo", { ids: [fatt.id], mezzo: m, overwrite: true });
    toast.success("Metodo di pagamento salvato");
  } catch { toast.error("Errore salvataggio metodo"); }
};

export const OcrBadges = ({ o }) => (
  <div className="flex flex-wrap gap-1 mt-1">
    {(o?.ddt_riferiti || []).length > 0 && (
      <Badge variant="outline" className="text-[10px]" data-testid="ocr-badge-ddt"><Truck className="h-3 w-3 mr-1" />{o.ddt_riferiti.length} DDT trovati</Badge>
    )}
    {(o?.pagamento_effettuato || o?.stato_pagamento === "pagata") && (
      <Badge className="text-[10px] bg-emerald-600 hover:bg-emerald-600" data-testid="ocr-badge-pagata"><CheckCircle2 className="h-3 w-3 mr-1" />Già pagata</Badge>
    )}
  </div>
);

export const PagamentoMetodoDialog = () => {
  const [pre, setPre] = useState(null);
  const resolveRef = useRef(null);
  useEffect(() => {
    opener = (p) => new Promise((resolve) => { resolveRef.current = resolve; setPre(p); });
    return () => { opener = null; };
  }, []);
  const finish = (m) => { resolveRef.current?.(m); resolveRef.current = null; setPre(null); };

  return (
    <Dialog open={pre !== null} onOpenChange={(o) => { if (!o && pre !== null) finish(""); }}>
      <DialogContent className="max-w-sm" data-testid="pagamento-metodo-dialog">
        <DialogHeader>
          <DialogTitle>Pagamento già effettuato</DialogTitle>
          <DialogDescription>Questo documento risulta già pagato. Seleziona il metodo di pagamento utilizzato:</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {SCELTE.map(([v, l]) => (
            <Button key={l} variant={pre === v && v ? "default" : "outline"} className="h-12 text-base" onClick={() => finish(v)}
                    data-testid={`pagamento-metodo-${v || "none"}`}>{l}</Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
